import { createCompoundContext } from '@/lib/context';

export type Gallery = 'strapPdpCarousel' | 'watchPdpCarousel';

export const { CompoundProvider, useCompoundContext } = createCompoundContext<{
  gallery?: Gallery;
  isProcessing: boolean;
}>('ImageCarousel');
